import { useState, useRef } from 'react';

export const useUIState = () => {
  const [popup, setPopup] = useState({
    isOpen: false,
    position: '',
    teamIndex: null,
    positionIndex: null
  });
  const [sorting, setSorting] = useState({
    field: 'name',
    direction: 'asc'
  });
  const [searchTerm, setSearchTerm] = useState('');
  const [autocomplete, setAutocomplete] = useState({
    isOpen: false,
    fieldId: null,
    searchText: '',
    position: null,
    suggestions: []
  });
  const autocompleteRef = useRef(null);
  const [draftPosition, setDraftPosition] = useState(0);
  const [quickSearch, setQuickSearch] = useState('');
  const [quickSearchResults, setQuickSearchResults] = useState([]);
  const [recommendedPlayer, setRecommendedPlayer] = useState(null);
  const [recommendedEV, setRecommendedEV] = useState(0);
  const [picksUntilNextTurn, setPicksUntilNextTurn] = useState(0);
  const [futureProjected, setFutureProjected] = useState(0);
  const [positionEVs, setPositionEVs] = useState({});
  const [isRecommending, setIsRecommending] = useState(false);
  const [isRecommendationExpanded, setIsRecommendationExpanded] = useState(false);
  const [isFullAutoDrafting, setIsFullAutoDrafting] = useState(false);
  const [showPlayersView, setShowPlayersView] = useState(false);
  const [playersSorting, setPlayersSorting] = useState({
    field: 'projected',
    direction: 'desc'
  });

  return {
    popup,
    setPopup,
    sorting,
    setSorting,
    searchTerm,
    setSearchTerm,
    autocomplete,
    setAutocomplete,
    autocompleteRef,
    draftPosition,
    setDraftPosition,
    quickSearch,
    setQuickSearch,
    quickSearchResults,
    setQuickSearchResults,
    recommendedPlayer,
    setRecommendedPlayer,
    recommendedEV,
    setRecommendedEV,
    picksUntilNextTurn,
    setPicksUntilNextTurn,
    futureProjected,
    setFutureProjected,
    positionEVs,
    setPositionEVs,
    isRecommending,
    setIsRecommending,
    isRecommendationExpanded,
    setIsRecommendationExpanded,
    isFullAutoDrafting,
    setIsFullAutoDrafting,
    showPlayersView,
    setShowPlayersView,
    playersSorting,
    setPlayersSorting
  };
};
